import { render, staticRenderFns } from "./usergroup-maintain-orders.vue?vue&type=template&id=06e5e04b"
import script from "./usergroup-maintain-orders.vue?vue&type=script&lang=js"
export * from "./usergroup-maintain-orders.vue?vue&type=script&lang=js"
import style0 from "./usergroup-maintain-orders.vue?vue&type=style&index=0&id=06e5e04b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports